import React, { useState, useEffect } from 'react';
import {
  Box,
  DialogContent,
  Button,
  DialogActions,
  Typography,
  CircularProgress,
} from '@mui/material';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../common/dialog/BootstrapDialog';
import * as chanceApi from '../../lib/api/chance';

// PDF 미리보기/다운로드 (Excel → PDF, 서버/Gotenberg 변환 — 2026-10-20 ksm 포팅).
// 이전의 html2canvas+jsPDF 클라이언트 캔버스 렌더링(EstimatePreview 직접 렌더 후 캡처)은
// 탭 프리즈 버그(bito 이슈 #10) 위험이 있어 제거하고, chancemng/projectmng EstimateModal과
// 동일한 서버 PDF(iframe) 패턴으로 교체했다.
const EstimatePreviewModal = ({ open, handleClose, estimate }) => {
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const qteUuid = estimate?.qteUuid;

  useEffect(() => {
    if (!open) return;

    if (!qteUuid) {
      setErrorMessage('견적서 정보를 찾을 수 없습니다.');
      return;
    }

    setErrorMessage(null);
    loadPdfPreview();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, qteUuid]);

  useEffect(() => {
    return () => {
      if (pdfPreviewUrl) {
        window.URL.revokeObjectURL(pdfPreviewUrl);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadPdfPreview = async () => {
    setLoading(true);
    try {
      const res = await chanceApi.downloadQuotePdf(qteUuid);
      const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      setPdfPreviewUrl(pdfUrl);
    } catch (err) {
      const message =
        typeof err.response !== 'undefined'
          ? err.response.data?.message || 'PDF 변환 서비스에 연결할 수 없습니다.'
          : err.message;
      setErrorMessage('PDF 미리보기 실패: ' + message);
    } finally {
      setLoading(false);
    }
  };

  const handlePdfDownload = () => {
    if (!pdfPreviewUrl) return;
    const link = document.createElement('a');
    link.href = pdfPreviewUrl;
    link.download = (estimate?.cstNm || '견적서') + '.pdf';
    link.click();
  };

  const onClose = () => {
    if (pdfPreviewUrl) {
      window.URL.revokeObjectURL(pdfPreviewUrl);
      setPdfPreviewUrl(null);
    }
    handleClose();
  };

  return (
    <BootstrapDialog open={open} onClose={onClose} fullWidth={true} maxWidth="lg">
      <BootstrapDialogTitle onClose={onClose}>
        견적서 미리보기
      </BootstrapDialogTitle>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DialogContent
          dividers
          sx={{
            height: '70vh',
            p: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : pdfPreviewUrl ? (
            <iframe
              src={pdfPreviewUrl}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
              title="견적서 PDF 미리보기"
            />
          ) : (
            <Typography color="text.secondary" sx={{ px: 3, textAlign: 'center' }}>
              {errorMessage || 'PDF를 불러올 수 없습니다.'}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="warning"
            onClick={handlePdfDownload}
            disabled={!pdfPreviewUrl}
          >
            PDF 다운로드
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
};

export default EstimatePreviewModal;
